import React, { Component } from 'react'
import PageTitle from '../../components/PageTitle'
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import Button from '@material-ui/core/Button';
import { Grid, Typography } from "@material-ui/core";
import { Translate } from '../../utils/Translate';
import '../Contact/Contact.css';
import Routes from '../../components/Router/Routes'

class Contact extends Component {

    constructor(props) {
        super(props);
        this.myForm = React.createRef();
        this.state = {
            formData: {
                email: '',
                name: '',
                message: ''
            },
            submitted: false,
            isFormDone: false
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleEmail = this.handleEmail.bind(this);
    }

    handleChange(event) {
        const { formData } = this.state;
        formData[event.target.name] = event.target.value;
        this.setState({ formData });
    }

    handleSubmit() {
        this.setState({ submitted: true }, () => {
            this.props.onSendMail(this.state.formData.name, this.state.formData.email, this.state.formData.message);
        });
    }

    handleEmail(){
        const matchRegexp =  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{1,}))$/
            return String(this.state.formData.email).toLowerCase()
            .match(
                matchRegexp
            );
    }

    componentDidUpdate(){
        if (this.state.formData.email.length !== 0 && this.handleEmail() && this.state.formData.name.length !== 0 && this.state.formData.message.length !== 0) {
            if (this.state.isFormDone === false) {

                this.setState({
                    isFormDone: true,
                })
            }
        }
        else {
            if (this.state.isFormDone === true) {
                this.setState({ isFormDone: false })
            }
        }
    }
    render() {
        const { formData } = this.state;
        let body;
        if (this.state.submitted === true) {
            body = (
                <div className="page-container">
                <div className="m-t-55 m-t-xs-20 browse-collection-menu">
                    <div className="m-b-xs-10 m-t-xs-20">
                    <PageTitle label={Translate({ id: "contact.Thanks" })} />
                    <Typography variant="h6" className="text-gray m-b-xs-10" >
                        {Translate({ id: "contact.ThanksMessage" })}</Typography>
                        </div>
                    <div className="m-t-55 m-t-xs-20">
                    <Button
                            fullWidth
                            variant="contained"
                            color="secondary"
                            className="button m-t-xs-20 m-t-contact-button btn-default"
                            onClick={() => {this.props.history.push({ pathname: Routes.homePage })}}
                          >
                            <Typography variant="button">                              
                              {Translate({ id: "contact.BackToHome" })}
                            </Typography>
                          </Button>
                    </div>
                    </div>
                </div>
            );
        }
        else {
            body = (
                <div className="page-container">
                <Grid container>
                    {/* <Grid item xs={3} sm={3}></Grid> */}
                        <ValidatorForm
                            ref="form"
                            onSubmit={this.handleSubmit}
                            className="form-container"
                        >
                            <PageTitle label={Translate({ id: "contact.Title" })} class="m-b-contact" TiltleBackColor="white" />

                            <div className="">
                                <span className="errorMessage">{this.props.errorMessage}</span>
                            </div>

                            <TextValidator
                                fullWidth
                                label={Translate({ id: "contact.Name" })}
                                onChange={this.handleChange}
                                name="name"
                                value={formData.name}
                                validators={['required']}
                                errorMessages={[Translate({ id: 'contact.NameRequired' })]}
                            />
                            <br />
                            <TextValidator
                                fullWidth
                                label={Translate({ id: "contact.Email" })}
                                onChange={this.handleChange}
                                name="email"
                                value={formData.email}
                                validators={['required', 'isEmail']}
                                errorMessages={[Translate({ id: 'login.EmailRequired' }), Translate({ id: 'login.EmailValidFormat' })]}
                            />
                            <br></br>
                            <TextValidator
                                fullWidth
                                label={Translate({ id: "contact.Message" })}
                                onChange={this.handleChange}
                                name="message"
                                value={formData.message}
                                validators={['required']}
                                errorMessages={[Translate({ id: 'contact.MessageRequired' })]}
                                className="messageHolder"
                                multiline
                            />                            
                            <div className="m-tb-5 m-tb-xs-5">
                                <Button
                                    disabled={!this.state.isFormDone}
                                    fullWidth
                                    type="submit"
                                    variant="contained"
                                    color="secondary"
                                    className="button m-t-contact-button btn-default"
                                >
                                    <Typography variant="button">{Translate({ id: "contact.Send" })}</Typography>
                                </Button>
                                <br /><br />
                                <br /><br />
                            </div>
                        </ValidatorForm>
                    {/* <Grid item xs={3} sm={3}></Grid> */}
                </Grid>
                </div>
            );
        }

        return (<div>{body}</div>);
    }
}

export default Contact
